/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemRefundTaxRef,
  LineItemRefundTaxRefOptional,
  LineItemRefundTaxRefMetaI,
  LineItemRefundTaxRefTrackedI,
} from "./line-item-refund-tax-ref";
import {
  LineItemRefundTaxRefTracked,
  LineItemRefundTaxRefMeta,
} from "./line-item-refund-tax-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemTaxRef,
  LineItemTaxRefOptional,
  LineItemTaxRefMetaI,
  LineItemTaxRefTrackedI,
} from "./line-item-tax-ref";
import { LineItemTaxRefTracked, LineItemTaxRefMeta } from "./line-item-tax-ref";

/**
 *
 * @export
 * @interface LineItemRefundTaxFull
 */
export interface LineItemRefundTaxFullOptional extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundTaxFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundTaxFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundTaxFull
   */
  assignId?: number;
  /**
   *
   * @type {LineItemTaxRef}
   * @memberof LineItemRefundTaxFull
   */
  taxId?: LineItemTaxRefOptional;
}

export interface LineItemRefundTaxFull
  extends LineItemRefundTaxFullOptional, Deletable, LineItemRefundTaxRef {
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundTaxFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundTaxFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundTaxFull
   */
  assignId: number;
  /**
   *
   * @type {LineItemTaxRef}
   * @memberof LineItemRefundTaxFull
   */
  taxId?: LineItemTaxRef;
}

export interface LineItemRefundTaxFullTrackedI extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundTaxFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundTaxFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundTaxFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {LineItemTaxRef}
   * @memberof LineItemRefundTaxFull
   */
  taxId?: LineItemTaxRefTrackedI;
  taxIdIsSet: boolean;
}

transformDatesMap.set(
  "LineItemRefundTaxFull",
  function (model: LineItemRefundTaxFull) {
    const transformDatestaxId = transformDatesMap.get("LineItemTaxRef");
    if (transformDatestaxId && model.taxId) {
      transformDatestaxId(model.taxId);
    }
  },
);

export type LineItemRefundTaxFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  taxId: PropertyMeta<LineItemTaxRefMetaI>;
}>;

export var LineItemRefundTaxFullMeta: LineItemRefundTaxFullMetaI =
  {} as LineItemRefundTaxFullMetaI;
LineItemRefundTaxFullMeta = typeMeta("LineItemRefundTaxFull", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  taxId: propertyMeta("taxId", false, false, false, LineItemTaxRefMeta),
});

const metaI = LineItemRefundTaxFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([LineItemRefundTaxRefMeta]);
  metaI.assignId.inheritedFrom = LineItemRefundTaxRefMeta.assignId;
});

export class LineItemRefundTaxFullTracked
  extends DeletableTracked
  implements LineItemRefundTaxFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  taxId__I?: LineItemTaxRefTracked = undefined;
  taxIdIsSet: boolean = false;
  set taxId(v: undefined | LineItemTaxRefTracked) {
    if (v !== undefined) {
      this.taxId__I = v;
      this.taxIdIsSet = true;
    } else {
      this.taxId__I = v || undefined;
      this.taxIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get taxId() {
    return this.taxId__I;
  }
  constructor(config?: LineItemRefundTaxFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.taxId?.setIds();
  }
  assignFrom(
    config: LineItemRefundTaxFullOptional,
    options?: AssignOptions,
  ): LineItemRefundTaxFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.taxId && this.taxIdApplyFilter(optionsRequired.filter)) {
      this.taxId = new LineItemTaxRefTracked(config.taxId, options);
      if (optionsRequired.unassign) this.taxIdIsSet = false;
      else this.taxIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): LineItemRefundTaxFullTrackedI {
    const cloned = {} as LineItemRefundTaxFullTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.taxIdIsSetDeep() &&
      this.taxIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.taxIdIsSet = true;
      cloned.taxId = this.taxId?.removeUnset(filter);
    } else {
      //cloned.taxIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): LineItemRefundTaxFullTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.taxIdApplyFilter(filter)) this.taxIdIsSet = false;
    this.taxId?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundTaxFullMeta.isDeleted,
      LineItemRefundTaxFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundTaxFullMeta.isNew,
      LineItemRefundTaxFullMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundTaxFullMeta.assignId,
      LineItemRefundTaxFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  taxIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundTaxFullMeta.taxId,
      LineItemRefundTaxFullMeta,
      this.taxId,
      this,
    );
  }
  taxIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.taxIdIsSet && this.taxIdApplyFilter(filter)) return true;
    return this.taxId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.taxIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
